import { render, staticRenderFns } from "./CustomersProfileMeili.vue?vue&type=template&id=5c73aa48"
import script from "./CustomersProfileMeili.vue?vue&type=script&lang=js"
export * from "./CustomersProfileMeili.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports